// C5 v2.12 / C4 v1.6.9 (Bojan, 2 Nov 2026): both SKU drawers, twice as wide, each month coloured against the one before.

// Twice the old 64rem, never wider than the screen less 1rem a side; sm: lets cn() drop the dialog's sm:max-w-sm.
export const SKU_DRAWER_WIDTH = "sm:max-w-[min(128rem,calc(100%-2rem))]";

export type MonthMove = "up" | "down" | null;

export const MONTH_MOVE_LEGEND = "Red: higher than the month before it in view. Green: lower. Black: the first month, no change, or no value; a month after a dash compares with the last month that has a value.";

// The value as printed, in hundredths: the drawers print |value| < 0.005 as 0.00 and otherwise value.toFixed(2).
function shownHundredths(value: number): number {
  return Math.abs(value) < 0.005 ? 0 : Math.round(Number(value.toFixed(2)) * 100);
}

// values: one entry per month column, oldest first; null or undefined = the cell shows a dash.
// Returns one entry per value: "up" (higher than the last earlier value), "down" (lower), null (first value, same, or no value).
export function monthMoves(values: ReadonlyArray<number | null | undefined>): MonthMove[] {
  let previous: number | null = null;
  return values.map((value) => {
    if (value === null || value === undefined || !Number.isFinite(value)) return null;
    const shown = shownHundredths(value);
    const move: MonthMove = previous === null ? null : shown > previous ? "up" : shown < previous ? "down" : null;
    previous = shown;
    return move;
  });
}

// The same tokens the Cost History and Sold Costs lists use (format.ts moveClass), without their bold.
export function monthMoveClass(move: MonthMove): string | undefined {
  return move === "up" ? "text-ks-danger" : move === "down" ? "text-ks-pass" : undefined;
}
